<template>
  <div class="export" v-loading="loading">
    <div class="export__header">
      <span class="title">PHYSICIANS REPORT</span>
    </div>

    <div class="export__footer">
      <el-row :gutter="15">
        <el-col :span="24">
          <div class="collapse-header">
            <div class="header-section border-line">
              <ul class="data-include-sub-header">
                <li class="checkbox-sub-header">Data Includes:</li>
                <li class="search-checkbox">
                  <el-checkbox v-model="checkAll" @change="handleCheckAllChange"
                    >Check All</el-checkbox
                  >
                </li>
              </ul>
              <el-button class="download-btn" @click="downloadPhysicians">
                Download
              </el-button>
            </div>

            <div class="date-includes">
              <div class="date-includes">
                <el-checkbox-group
                  v-model="activeFieldList"
                  @change="isCheckAll"
                >
                  <ul class="check-list">
                    <li
                      v-for="(item, index) in exportPhysiciansExcelFields"
                      :key="index"
                      class="search-checkbox"
                    >
                      <el-checkbox :label="item.value">
                        {{ item.label }}
                      </el-checkbox>
                    </li>
                  </ul>
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import exportExcelHelper from "@/mixins/exportExcelHelper";
export default {
  data() {
    return {
      checkAll: true,
      fieldList: [],
      activeFieldList: [],
      loading: false,
    };
  },
  mixins: [exportExcelHelper],
  mounted() {
    this.checkDefaultExport();
  },
  methods: {
    checkDefaultExport() {
      this.onExportPhysicians();
    },
    loadFieldsList() {
      this.exportPhysiciansExcelFields.forEach((obj) => {
        this.fieldList.push(obj.value);
      });
      this.activeFieldList = this.fieldList;
    },
    onExportPhysicians() {
      this.loadFieldsList();
    },
    async downloadPhysicians() {
      if (this.activeFieldList.length) {
        this.loading = true;
        let params = {
          include: this.activeFieldList,
        };
        if (this.search_string != "") {
          params.search_string = this.search_string;
        }
        await this.$store.dispatch("physicians/downloadPhysiciansData", params);
        this.loading = false;
      } else {
        this.$message({
          message: "Please select the data fields.",
          type: "warning",
        });
      }
    },
    handleCheckAllChange(val) {
      this.activeFieldList = val ? this.fieldList : [];
    },
    isCheckAll() {
      if (
        this.activeFieldList &&
        this.exportPhysiciansExcelFields &&
        this.activeFieldList.length &&
        this.exportPhysiciansExcelFields.length &&
        this.activeFieldList.length == this.exportPhysiciansExcelFields.length
      ) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
  },
};
</script>

<style></style>
